import { ApiResult, httpRequest, Urls } from './Shared';

const LOCATION_SEARCH_URL = `${Urls.BASE_URL}/LocationSearch`;

export interface StateSearchResult {
    stateInitials: string;
    stateName: string;
}

export interface StateInformation extends StateSearchResult {
    swLat?: number;
    swLng?: number;
    neLat?: number;
    neLng?: number;
}

export interface CitySearchResult {
    cityId: number;
    cityName: string;
    stateInitials: string;
    zip?: string;
}

export interface PropertySearchResult {
    propertyId: number;
    propertyName: string;
    cityName: string;
    stateInitials: string;
    zip?: string;
}

export interface LocationSearchResults {
    stateResult: StateSearchResult[];
    cityResult: CitySearchResult[];
    propertyResult: PropertySearchResult[];
}

export const getStateInformations = (): Promise<ApiResult<StateInformation[]>> => {
    return httpRequest<StateInformation[]>(`${LOCATION_SEARCH_URL}/stateInfo`, 'get');
};

export const addStateInformation = (info: StateInformation) =>
    httpRequest<boolean>(`${LOCATION_SEARCH_URL}/stateInfo`, 'post', info);

export const searchStates = (searchTerm: string) =>
    httpRequest<StateSearchResult[]>(`${LOCATION_SEARCH_URL}/state/${searchTerm}`);

export const searchCities = (searchTerm: string, stateAbbreviations: string[]) =>
    httpRequest<CitySearchResult[]>(
        `${LOCATION_SEARCH_URL}/city/${searchTerm}?stateAbbreviations=${stateAbbreviations.join(
            ','
        )}`
    );

export const searchProperties = (searchTerm: string) =>
    httpRequest<PropertySearchResult[]>(`${LOCATION_SEARCH_URL}/property/${searchTerm}`);

export const searchLocations = (searchTerm: string) =>
    httpRequest<LocationSearchResults>(`${LOCATION_SEARCH_URL}/${searchTerm}`, 'get');



// WEBPACK FOOTER //
// ./src/api/LocationSearch.ts